import { render, staticRenderFns } from "./phoneSheet.vue?vue&type=template&id=543c5ca8&scoped=true"
import script from "./phoneSheet.vue?vue&type=script&lang=js"
export * from "./phoneSheet.vue?vue&type=script&lang=js"
import style0 from "./phoneSheet.vue?vue&type=style&index=0&id=543c5ca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543c5ca8",
  null
  
)

export default component.exports